export const initialState = {
  versions: []
}

export default function(state=initialState, action) {
  const { type } = action
  const payload = action.payload || {}
  const data = payload.data || {}

  switch(type) {
    case 'SHOP_ORDER_VERSIONS_LOAD_SUCCEEDED':
      return {
        ...state,
        versions: data
      }
    default:
      return state
  }
}
